import { CASE_SET_VIEWER_CONTROL } from './constants';

export function setViewerControl(viewerControl) {
  return {
    type: CASE_SET_VIEWER_CONTROL,
    data: viewerControl,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_SET_VIEWER_CONTROL:
      return {
        ...state,
        viewerControl: action.data,
      };

    default:
      return state;
  }
}
